import { Box, FormLabel } from '@mui/material';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ColorEntry = ({ name, value, onChange, disabled }) => {
  const [selectedColor, setSelectedColor] = useState(value || '#000000');

  useEffect(() => {
    if (value) {
      setSelectedColor(value);
    }
  }, [value]);

  const handleColorChange = (event) => {
    const newColor = event.target.value;
    setSelectedColor(newColor);
    if (onChange) {
      onChange(newColor);
    }
  };

  return (
    <Box mt={1}>
      <FormLabel component="legend" sx={{ color: 'black', mb: 1 }}>{name}</FormLabel>
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        mt={1}
        sx={{
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          padding: '8px 12px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
          maxWidth: 240
        }}
      >
        <Box
          component="input"
          type="color"
          value={selectedColor}
          onChange={handleColorChange}
          disabled={disabled}
          sx={{
            width: 36,
            height: 36,
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            appearance: 'none',
            background: 'none',
            '&::-webkit-color-swatch-wrapper': {
              padding: 0
            },
            '&::-webkit-color-swatch': {
              border: 'none',
              borderRadius: '50%'
            },
            '&:hover, &:focus': {
              outline: 'none',
              border: 'none',
              boxShadow: 'none'
            }
          }}
        />
        <Box fontSize={14} color="#333">{selectedColor.toUpperCase()}</Box>
      </Box>
    </Box>
  );
};

ColorEntry.propTypes = {
  name: PropTypes.any,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default ColorEntry;
